<template>
  <div>
    <div v-if="is_loading" class="is-flex is-justify-content-center is-align-items-center">
      <div class="loading"></div>
    </div>
    <div v-else>
      <p>
        לא נמצא רישום לשעת יציאה בתאריך:
        <b>{{ login_date.getDate() + '/' + (login_date.getMonth() + 1) + '/' + login_date.getFullYear() }}</b>
        (בתאריך הזה התחברת בשעה {{ time_helper.getTimeInput(login_date) }})
      </p>
      <p v-if="last_stat">
        הפעולה האחרונה שרשומה שביצעת באותו היום היא:
        <b>{{ last_stat.title }}</b> בשעה <b>{{ time_helper.getTimeInput(last_stat.created_at) }}</b>
      </p>
      <div class="is-flex is-align-items-center">
        <p><b>שעת יציאה:</b></p>
        <div class="horizontal_space"></div>
        <div class="is-flex is-align-items-center">
          <div class="is-flex is-align-items-center">
            <input dir="ltr" v-model="confirmed_logout_time" placeholder="20:00" type="time"/>
          </div>
          <div class="horizontal_space"></div>
          <a @click="submit" class="button is-info" :class="{ faded: !isLogoutTimeValid, 'is-loading': is_submitting }">עדכן</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TimeHelper from '@/custom/classes/time_helper'
export default {
  name: 'presence-report-logout-confirmation',
  props: ['payload'],
  data () {
    return {
      is_loading: true,
      is_submitting: false,
      login_date: new Date(this.payload.login_date),
      last_stat: undefined,
      time_helper: new TimeHelper(),
      confirmed_logout_time: ''
    }
  },
  computed: {
    isLogoutTimeValid () {
      if (this.confirmed_logout_time.length == 0) {
        return false
      }
      if (this.login_date == undefined) {
        return true
      }
      let login_date = this.time_helper.setDate(this.login_date)
      let logout_date = this.time_helper.setTime(login_date, this.confirmed_logout_time)
      return logout_date.getTime() > new Date(this.login_date).getTime()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.is_loading = true
      let midnight_date = new Date(this.login_date)
      midnight_date.setDate(this.login_date.getDate() + 1)
      midnight_date.setHours(0, 0, 0, 0)
      this.$network_utils.getStats({
        page: 1,
        per: 1,
        sort: '-created_at',
        date_from: this.login_date.toUTCString(),
        date_to: midnight_date.toUTCString(),
        owner: this.payload.recruiter
      }).then(response => {
        this.is_loading = false
        this.last_stat = response[0]
        if (this.last_stat == undefined) {
          return
        }
        let last_stat_date = new Date(this.last_stat.created_at)
        last_stat_date.setMinutes(last_stat_date.getMinutes() + 1)
        this.confirmed_logout_time = this.time_helper.getTimeInput(last_stat_date)
      })
    },
    submit () {
      this.is_submitting = true
      let date = this.time_helper.setDate(this.login_date)
      date = this.time_helper.setTime(date, this.confirmed_logout_time)
      this.$network_utils.postStat({
        created_at: date.toUTCString(),
        title: 'Recruiter Logged Out',
        designator: 'recruiter_logout',
        content: `${this.payload.recruiter} התנתק/ה`,
        status: 'done',
        owner: this.payload.recruiter,
        priority: 5,
        resource_id: 1,
        resource_type: 'Admin'
      }).then(() => {
        this.is_submitting = false
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
